var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-width relative-position scrollable-section"},[_c('claims-history',{staticClass:"q-pa-lg",staticStyle:{"max-width":"800px"},attrs:{"claim-versions":_vm.portfolio.claimsHistory,"include-peer-review":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }